module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-box-image-bg-sp-58a59c20d035fe46e1f071d5ec7e5cd7.png";